function asciiDigits(value) {
  const persian = "۰۱۲۳۴۵۶۷۸۹";
  const arabic = "٠١٢٣٤٥٦٧٨٩";
  return String(value || "")
    .replace(/[۰-۹]/g, digit => String(persian.indexOf(digit)))
    .replace(/[٠-٩]/g, digit => String(arabic.indexOf(digit)))
    .replace(/\D/g, "");
}

export function normalizeIranianMobile(value) {
  return asciiDigits(value).slice(0, 11);
}

export function isValidIranianMobile(value) {
  return /^09\d{9}$/.test(asciiDigits(value));
}
